import { Observable } from 'rxjs';
import { IPlaybooksItemDTO } from '../../../dto/playbooks-listening.dto';
import { IGuideLineListFilter } from '../playbook-list.component';
import { InjectionToken } from '@angular/core';
import { IPlaybookGuidelineRunItem } from './playbook-guideline-run-tile.component';



export interface IPlaybookListFacadeService {
    legalHubFilters$: Observable<IGuideLineListFilter>;
    legalHubSelectedPlaybook$: Observable<IPlaybooksItemDTO>;
    rightBarHigherZindex$:Observable<boolean>;

    setLegalHubPlaybook(playbook: IPlaybooksItemDTO): void;
    openLegalHubSidebar(guideLine: IPlaybookGuidelineRunItem): void;
    setLegalHubFilters(filters: IGuideLineListFilter):void;
    setRightBarHigherZindex(higher: boolean):void;
}

export const IPlaybookListFacadeServiceToken = new InjectionToken<IPlaybookListFacadeService>('IPlaybookListFacadeServiceToken');